/* eslint-disable @typescript-eslint/no-unsafe-return */
import { isFunction } from 'lodash'
import React from 'react'
import { WidgetProps } from 'react-jsonschema-form'

import PhoneNumber from '../../inputs/PhoneNumber'

const PhoneWidget = ({
  id,
  required,
  readonly,
  disabled,
  label,
  value,
  onChange,
  onBlur,
  onFocus,
  autofocus,
  options,
  schema,
}: WidgetProps) => {
  const handleChange = (targetValue: string) =>
    isFunction(onChange) && onChange(targetValue === '' ? options.emptyValue : targetValue)
  const handleBlur = ({ target: { value: targetValue } }: React.FocusEvent<HTMLInputElement>) =>
    isFunction(onBlur) && onBlur(id, targetValue)
  const handleFocus = ({ target: { value: targetValue } }: React.FocusEvent<HTMLInputElement>) =>
    isFunction(onFocus) && onFocus(id, targetValue)

  return (
    <PhoneNumber
      autofocus={autofocus}
      disabled={disabled || readonly}
      id={id}
      label={label || schema.title || 'Phone number'}
      required={required}
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      value={value}
      onBlur={handleBlur}
      onChange={handleChange}
      onFocus={handleFocus}
    />
  )
}

export default PhoneWidget
